/* eslint-disable no-nested-ternary */
import colors from "../../assets/css/colors.scss";

const reactSelectOverWriteStyles = {
  container: () => null,
  control: (provided, { selectProps }) => ({
    ...provided,
    backgroundColor: selectProps.value && selectProps.value.value ? colors.gray : "transparent",
    padding: "10px 12px",
    borderRadius: "4px",
    height: "100%",
    cursor: selectProps.isSearchable ? undefined : "pointer",
    borderColor: undefined,
    borderStyle: undefined,
    borderWidth: undefined,
    minHeight: undefined,
    outline: undefined,
    boxShadow: undefined,
    "&:hover": {
      borderColor: "transparent"
    }
  }),
  valueContainer: provided => ({ ...provided, padding: undefined }),
  singleValue: provided => ({
    ...provided,
    marginLeft: undefined,
    marginRight: undefined,
    maxWidth: undefined,
    color: undefined,
    transform: undefined,
    top: undefined
  }),
  multiValue: provided => ({
    ...provided,
    marginLeft: undefined,
    maxWidth: undefined,
    margin: undefined,
    minWidth: undefined,
    backgroundColor: "#E8ECF2",
    borderRadius: "13px",
    fontSize: "11px",
    letterSpacing: "1.1px",
    marginRight: "2px"
  }),
  multiValueLabel: provided => ({
    ...provided,
    backgroundColor: colors.darkerGrey
  }),
  option: (provided, { isSelected, isFocused }) => ({
    ...provided,
    color: isSelected ? colors.inputBg : colors["mine-shaft-approx"],
    backgroundColor: isSelected ? colors["fern-approx"] : isFocused ? colors.lightGray : colors.inputBg,
    "&:hover": {
      backgroundColor: colors.lightGray
    },
    "&:focus": {
      backgroundColor: colors.lightGray
    }
  }),
  menu: provided => ({
    ...provided,
    top: "36px",
    left: "0",
    margin: "0",
    borderRadius: "0 0 4px 4px"
  }),
  multiValueRemove: provided => ({
    ...provided,
    paddingLeft: undefined,
    paddingRight: undefined,
    marginRight: "2px",
    color: colors.darkerGrey,
    "&:hover": {
      backgroundColor: "#E8ECF2",
      color: colors.darkerGrey
    }
  }),
  input: provided => ({ ...provided, margin: undefined, paddingBottom: undefined, paddingTop: undefined }),
  indicatorsContainer: provided => ({
    ...provided,
    height: "16px"
  }),
  dropdownIndicator: () => ({
    color: colors.darkGray
  }),
  clearIndicator: () => ({
    color: colors.darkGray
  })
};

export default reactSelectOverWriteStyles;
